export default "__VITE_ASSET__DoIWk1sV__"